import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Navbar, Nav,  NavDropdown, Button, Modal, Form } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/header.css";
import JuniorEatsLogo from "./assets/junior-eats-logo.png";



const Organization = ({ isAuthenticated, setIsAuthenticated }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false); 
  const [userDetails, setUserDetails] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return; // ✅ Prevent API call if not logged in
  
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("Token");
        const user_id = localStorage.getItem("userId");
        
        if (!token || !user_id) {
          console.warn("No token or user ID found");
          return;
        }
  
        const response = await axiosOrganizationInstance.get(`/user/${user_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        console.log("User Data from Header", response.data);
        setUserDetails({ name: response.data.name, email: response.data.email });
      } catch (error) {
        console.error("Error fetching user details:", error.response?.data || error.message);
      }
    };
  
    fetchUserDetails();
  }, [isAuthenticated]); // ✅ Depend on isAuthenticated
    
  

  const location = useLocation();
  
  const handleLogout = () => {
    setIsAuthenticated(false);

    // Clear items from localStorage
    localStorage.removeItem("Token"); // Remove the authentication token
    localStorage.removeItem("organizationId"); 
    localStorage.removeItem("userId"); 
  };

  const isSupportPage = location.pathname === "/support";
  

  // Header Component
  const Header = ({ isAuthenticated, onLogout, showLinks }) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [error, setError] = useState("");

    const handleShow = () => setShow(true);
    const handleClose = () => {
      setShow(false);
      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      setError("");
    };

    const handleUpdatePassword = () => {
        if (!oldPassword || !newPassword || !confirmNewPassword) {
          setError('All fields are required!');
          return;
        }
        if (newPassword !== confirmNewPassword) {
          setError('New Password and Confirm Password do not match!');
          return;
        }
    
        // Call API or handle password change logic here
        console.log('Password Updated:', { oldPassword, newPassword });
        handleClose(); // Close modal on success
      };
    const openSupportWindow = () => {
      const width = 600;
      const height = 400;
      const left = window.innerWidth / 2 - width / 2;
      const top = window.innerHeight / 2 - height / 2;
      const features = `width=${width},height=${height},top=${top},left=${left},resizable=yes`;

      const newWindow = window.open("/organization/support", "_blank", features);

      if (!newWindow) {
        alert("Please allow popups for this website");
      }
    };

    const toggleDropdown = () => {
      setIsDropdownVisible((prev) => !prev);
    };

    return (
      <div style={{ width: "100vw", display: "flex" ,flexDirection:'row',height:'15vh'}}>
        <div
          style={{
            width: "20%",
            backgroundColor: "#C5E2FC",
            // backgroundColor:'red',
            textAlign: "center",
            paddingLeft: "2vw",
          }}
        >
          <img
            src={JuniorEatsLogo}
            alt="Junior Eats"
            style={{
              height: "95%",
              margin: "5px auto",
              width: "98%",
              display: "block",
            }}
          />
        </div>
        <Navbar
          style={{
            backgroundColor: "#FFFFFF",
            // backgroundColor:'red',
            borderBottom: "1px solid #D1D1D6",
            width: "78%",
            height:'15vh',
            minHeight:'15vh',
            display:'flex',
            alignItems:'center'
          }}
          
          expand="lg"
        >
          {/* <div className="container-white" style={{height:'15vh',display:'flex',alignItems:'center',marginTop:'-8px',backgroundColor:'white',width:'100%'}}> */}
            
            <Navbar.Toggle aria-controls="basic-navbar-nav" style={{marginLeft:'auto',color:'#fff'}}/>

            {showLinks && (
              <Navbar.Collapse id="basic-navbar-nav" >
                <Nav className="me-auto">
                  {!isAuthenticated ? (
                    <>

                    </>
                  ) : null}
                </Nav>
                <Nav className="nav-collapse">
                  {isAuthenticated && (
                    <>
                      <a
                        className="support_link"
                        onClick={openSupportWindow}
                       
                      >
                        Support
                      </a>
                      <div
                        className="profile-dropdown-container"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <NavDropdown
                          // className="d-flex align-items-center"
                          show={isDropdownVisible} // Control visibility with state
                          onClick={toggleDropdown} // Toggle visibility on click
                          title={
                            <>
                              <PersonCircle
                                size={24}
                                style={{ color: "#000000", marginRight: "8px" }}
                              />
                              <span style={{ color: "#000000" }}>Profile</span>
                            </>
                          }
                          id="basic-nav-dropdown"
                          align="end"
                        >

                            <NavDropdown.Item>
                              {userDetails?.name ? userDetails.name : "Loading..."}
                              
                            </NavDropdown.Item>

                            <div className="dropdown-divider"></div>

                            {/* User Email */}
                            <NavDropdown.Item>
                              {userDetails?.email ? userDetails.email : "Loading..."}
                              
                            </NavDropdown.Item>
                            <div className="dropdown-divider"></div>  
                                                   
                         <NavDropdown.Item onClick={handleShow}>Change Password</NavDropdown.Item>

                         <div className="dropdown-divider"></div>{" "}
                          <NavDropdown.Item
                            as={Link}
                            to="https://jreats.com/"
                            onClick={onLogout}
                          >
                            Sign Out
                          </NavDropdown.Item>
                        </NavDropdown>

                      </div>
                    </>
                  )}
                </Nav>
              </Navbar.Collapse>
            )}
          {/* </div> */}
        </Navbar>
        <Modal show={show} onHide={handleClose} className="custom-modal"
        style={{
          marginRight:'10px',
        }}>
                            <Modal.Header >
                              <Modal.Title>Change Password</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{
                              maxHeight: '50vh',
                              overflowY: 'hidden',
                              display: "flex",
                              flexDirection: "column",
                              
                              }}>
                              {error && <p style={{ color: "red",}}>{error}</p>}
                             <Form>
                                <Form.Group className="mb-3">
                                  <Form.Label>Enter Old Password</Form.Label>
                                  <Form.Control
                                    type="password"
                                    placeholder=""
                                    value={oldPassword}
                                    onChange={(e) =>
                                      setOldPassword(e.target.value)
                                    }
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Enter New Password</Form.Label>
                                  <Form.Control
                                    type="password"
                                    placeholder=""
                                    value={newPassword}
                                    onChange={(e) =>
                                      setNewPassword(e.target.value)
                                    }
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Confirm New Password</Form.Label>
                                  <Form.Control
                                    type="password"
                                    placeholder=""
                                    value={confirmNewPassword}
                                    onChange={(e) =>
                                      setConfirmNewPassword(e.target.value)
                                    }
                                  />
                                </Form.Group>
                              </Form>
                            </Modal.Body>
                            <Modal.Footer >
                              <Button variant="secondary" onClick={handleClose}>
                                Close
                              </Button>
                              <Button
                                variant="primary"
                                onClick={handleUpdatePassword}
                              >
                                Update Password
                              </Button>
                            </Modal.Footer>
                          </Modal>
      </div>
    );
  };


  return (
    <>
      {/* Conditionally render Header and Footer based on isAuthenticated */}
      {isAuthenticated && (
        <Header
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
          onLogout={handleLogout}
          showLinks={!isSupportPage}
        />
      )}

    <div>
      <Outlet /> {/* ✅ This will render child routes like Dashboard */}
    </div>
    </>
  );
};

export default Organization;
